import moment from "moment";
import { useEffect, useState } from "react";
import { BiSend } from "react-icons/bi";
import { HiSortAscending } from "react-icons/hi";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import Api from "../../service/http";

const Details = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  const [textMessages, setTextMessages] = useState([]);

  const fetchAlert = async () => {
    try {
      const response = await Api.get(`web/text-messages/${id}`);
      setTextMessages(response.data);
    } catch (error) {
      alert('Failed to load alert details. Please try again.');
      navigate('/inbox');
    } finally {
      setInitialLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchAlert();
    } else {
      setInitialLoading(false);
    }
  }, [id]);

  const [message, setMessage] = useState("");
  const sendMessage = async () => {
    if (!message || loading) return;

    try {
      setLoading(true);
      await Api.post(`web/text-messages/${id}`, { message });
      setMessage("");
      fetchAlert();
    } catch (error) {
      alert('Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (initialLoading) {
    return (
      <div className="p-6 flex justify-center items-center h-[70vh]">
        <Loader className="m-auto" />
      </div>
    );
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold pb-2 border-b">{textMessages?.number}</h1>

      <div className="space-y-6 h-[75vh]">
        <div className="h-full flex items-end">

          <div className="w-full">
            <div className="">
              <div className="space-y-4 h-[67vh] overflow-y-auto">
                {textMessages?.messages?.map((message, index) => (
                  <div key={index} className={`p-3 rounded-lg ${message.type == 'outgoing' ? 'bg-blue-100 text-right' : 'bg-gray-100 text-left'}`}>
                    <p className="text-sm">{message?.message}</p>
                    <span className="text-xs text-gray-500">{moment(message?.created_at).fromNow()}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative mt-4">
              <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type your message..."
                className="border border-gray-300 rounded-md p-2 w-full pr-10"
              />
              <div className={`absolute right-3 top-1/2 -translate-y-1/2 text-[20px] cursor-pointer ${loading ? 'text-gray-500' : 'text-blue-500'}`} onClick={sendMessage}>
                {loading ? <HiSortAscending /> : <BiSend />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;